module.exports = __webpack_public_path__ + "media/images/hisp-logo-933250a11ced0894b6f4edf1a16f175b.png";